<template>
    <MainContainer>
        <h2>automatische Beitragssollstellung</h2>

        <b-form>
            <b-form-group
                label-for="inputYear"
                :label-size="size"
            >
                <template v-slot:label>
                    <template>Beiträge für bestimmtes Abrechnungsjahr suchen:</template>
                </template>
                <div class="d-flex">
                    <template v-if="years.busy">
                        <ContentLoadingBlock />
                    </template>
                    <template v-else>
                        <b-select
                            id="inputYear"
                            :options="years.options"
                            v-model="filter.year"
                            :size="size"
                        />
                    </template>
                    <b-button
                        variant="primary"
                        :size="size"
                        @click="fetchMitgliedsbeitraege"
                    >
                        anzeigen
                    </b-button>
                </div>
            </b-form-group>
        </b-form>

        <section
            v-if="items.length > 0"
            class="mitgliedsbeitraege-info"
        >
            <p>
                Für das Jahr <strong>{{ filter.year }}</strong> wurden die folgenden, noch nicht in Rechnung gestellten, Mitgliedsbeiträge ermittelt:
            </p>
        </section>

        <section class="mitgliedsbeitraege-list-container">
            <div>
                <strong>{{ pagination.total }}</strong> Datensätze gefunden
            </div>
                <Table
                    bordered
                    striped
                    small
                    showFilter
                    :responsive="true"
                    :fields="fields"
                    :items="items"
                    :isBusy="busy"
                    :sortBy="sortBy"
                    :sortDesc="sortDesc"
                    busyText="Lädt Mitgliedsbeiträge..."
                    emptyText="Keine offenen Mitgliedsbeiträge gefunden"
                    @sortChanged="sortChanged"
                >

                    <template v-slot:id="{ row: row }">{{ row.item.id }}</template>

                    <template v-slot:name="{ row: row }">{{ row.item.name }}</template>

                    <template v-slot:status="{ row: row }">{{ row.item.status }}</template>

                    <template v-slot:datum="{ row: row }">{{ date }}</template>

                    <template v-slot:beitrag="{ row: row }">{{ row.item.beitrag }}</template>

                </Table>
            <b-pagination
                v-if="pagination.step < pagination.total"
                v-model="pagination.current"
                :total-rows="pagination.total"
                :per-page="pagination.step"
                :size="size"
                align="center"
                @change="changePage"
            />
        </section>

        <div class="d-flex justify-content-end mb-3">
            <b-button
                type="submit"
                class="total-btn mr-1"
                variant="primary"
                :disabled="busy"
                @click="dataProvide"
            >
                <template v-if="!busy">einbuchen</template>
                <template v-else>
                    <Spinner small variant="light" />
                </template>
            </b-button>
            <b-button
                type="cancel"
                to="/fibu/mitgliedsbeitraege"
                class="total-btn"
                variant="outline-secondary"
            >
                Zurück
            </b-button>
        </div>

    </MainContainer>
</template>

<script>
import {ApiFactory} from "@/api/ApiFactory";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import Spinner from "@/components/Spinner/Spinner";
import CommonView from "@/mixins/CommonView/CommonView";
import Rights from "@/mixins/Rights/Rights";
import Size from "@/mixins/Size/Size";
import ContentLoadingBlock from "@/components/ContentLoadingBlock/ContentLoadingBlock";

const MitgliedsbeitraegeApi = ApiFactory.get('fiBuMitgliedsbeitraegeApi');

export default {
    name: "FiBuMitgliederBeitraegeUebersicht",
    mixins: [CommonView, Rights, Size],
    components: {
        Table,
        MainContainer,
        Spinner,
        ContentLoadingBlock
    },
    data() {
        return {
            filter: {
              year: null
            },
            fields: [
                {
                    key: 'id',
                    label: 'Mitglied-ID',
                    sortable: true,
                },
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                },
                {
                    key: 'datum',
                    label: 'Datum',
                    sortable: false,
                },
                {
                    key: 'beitrag',
                    label: 'Beitrag',
                    Sortable: false,
                }
            ],
            years: {
                busy: false,
                items: [],
                options: []
            },
            busy: false,
            prefetch: false,
            items: [],
            data: {},
            pagination: {},
            lSortBy: null,
            sortDesc: false,
            api: MitgliedsbeitraegeApi
        }
    },
    created() {
        this.filter.year = this.$moment().format('Y');
        this.fetchMitgliedsbeitraege();
        this.getYears();
    },
    methods: {
        async fetchMitgliedsbeitraege() {
            this.busy = true;

            const response = await MitgliedsbeitraegeApi.getMitgliedsbeitraegeToBook({
                filter: this.filter,
                page: this.pagination.current,
                limit: this.pagination.limit,
                order: this.lSortBy,
                sort: this.sortDesc ? "desc" : "asc"
            });
            if(response.ok) {
                    let data = response.json.collection.map(item => {
                        return {
                            id: item.id,
                            status: item.status,
                            name: `${item.name}, ${item.vorname}`,
                            beitrag: item.beitrag
                        }
                    });

                    this.items = data;

                    this.pagination.step = response.json.pagination.step;
                    this.pagination.total = response.json.pagination.total;
                    this.pagination.current = response.json.pagination.page;
            } else {
                this.data = [];
                this.pagination.total = 0;
                this.items = [];
            }
            this.busy = false;
        },
        async dataProvide() {
            this.busy = true;

            const date = new Date().toISOString().slice(0,10);

            let data = {
                datum: date,
                year: this.filter.year
            }

            const response = await MitgliedsbeitraegeApi.postMitgliedsBeitraege(data);

            if(response.ok) {
                this.items = [];
                const mitgliedsbeitraegeAnzahl = response.json.collection[0];
                const year = this.filter.year;

                this.makeToast(
                    'Mitgliedsbeiträge erstellt',
                    `Es wurden ${mitgliedsbeitraegeAnzahl} Mitgliedsbeiträge für das Jahr ${year} in die offenen Posten verschoben.`,
                    'success'
                );
                this.fetchMitgliedsbeitraege();

            } else {
                this.fetchMitgliedsbeitraege();

                this.makeToast(
                    'Fehler',
                    'Etwas ist schiefgelaufen, bitte versuchen Sie es erneut.',
                    'danger'
                );
            }

            this.busy = false;
        },
        sortChanged(ctx) {
            this.pagination.current = 1;
            this.lSortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.fetchMitgliedsbeitraege();
        },
        changePage(page) {
            this.pagination.current = page;
            this.fetchMitgliedsbeitraege();
        },
        getYears() {
            const currentDate = new Date();
            let startDate = 2009;
            let currentYear = currentDate.getFullYear();

            const years = [];
            while (startDate <= (currentYear + 1)) {
                years.push({ text: startDate, value: startDate });
                startDate++;
            }

            years.splice(0, 0, {text: 'Datum auswählen', value: null});

            this.years.options = years;
        }
    },
    computed: {
        sortBy() {
            return this.lSortBy
                ? this.lSortBy
                : this.filter
                ? this.filter.orderby
                : null;
        },
        date() {
            const options = {
                year: "numeric",
                month: "2-digit",
                day: "numeric",
            };
            let date = new Date();

            return date.toLocaleDateString('de-DE', options);
        }
    }
}
</script>